// Define lightning icon properties
const iconLightning = L.icon({
  iconUrl: 'https://pbsweather.org/wp-content/uploads/wxicons/lightning-v3.gif',
  iconSize: [15, 15]
})

export { iconLightning }